export class RegistersModel {
    idCard: number;
    titleName: string;
    firstName: string;
    lastName: string;
    username: string;
    hospitalCode: string;
    hospitalName: string;
    email: string;
    createBy: string;
    fileList: FileListModel[];
}

export class FileListModel {
    fileName: string
    file: string
}